import memoize from 'lodash/memoize';

const pageNameMapper = {
  home: 'plan-home',
  '/': 'home',
  '/home': 'home',
  '/home/plans': 'plans',
  '/new': 'new-plan',
  '/privacy': 'privacy',
  '/terms': 'terms',
};

function getViewName(path: string): string {
  const match = pageNameMapper[path];

  if (match) {
    return match;
  }
  const regex =
    /\/@[^/]+\/[^/]+\/(maps|presentation|board|whiteboards|sections|dashboard|order|new-artifact|settings|new|cards|files|home)/;
  const matchRegex = path.match(regex);
  if (matchRegex) {
    const matchedPath = matchRegex[1];
    return pageNameMapper[matchedPath] || matchedPath;
  }

  return path;
}

function cleanPath(path: string): string {
  return path.replace(/\/\d+(?=\/|$)/g, '/0');
}

export default memoize(getViewName, cleanPath);
